export const locales = ['cz', 'en'];
export const defaultLocale = 'cz';
export const timeZone = 'Europe/Prague';
